<template>
  <div class="display">
    <v-alert v-show="true" color="primary" value="true" outline>
      {{ $t('absWarning') }} <code>{{ $store.state._Sites.siteSelected.LIC_URL }}</code>
    </v-alert>    
    <v-alert v-show="displayDefault === 'default_agents'" color="secondary" icon="warning" value="true" outline>
      {{ $t('absWarning2') }}
    </v-alert>
    <!-- Chargement -->
    <div v-if="loadingGet" class="text-xs-center">
      <v-progress-circular indeterminate class="primary--text" :size="100" :width="1"></v-progress-circular>
    </div>
    <div v-else>
      <!-- Messaging  ON / OFF -->
      <v-card class="mb-3">
        <v-card-text>
          <v-layout row>
            <v-flex xs6>
              <v-switch 
                :label="abs.active ? $t('absTitle') + ' ON' : $t('absTitle') + ' OFF'"
                light
                v-model="abs.active"
                color="primary"
                @change="switchAbs()"
                :disabled="testBrideStatus('parametre_messaging')"
              ></v-switch>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>

      <v-expansion-panel
        v-if="!messagingOnOff"
      >
        <!-- formulaire en absence-->
        <v-expansion-panel-content
          :disabled="testBrideStatus('parametre_chat_formprechat') || messagingOnOff"
        >
          <div slot="header"><v-icon class="mr-2 primary--text">assignment</v-icon>{{ $t('absPerso') }}<!--<code>{{ abs.active ? $t("yes") : $t("no") }}</code>--></div>
          <v-card class="mb-3">
            <v-card-text>
              <v-layout row wrap>
                <v-flex xs12>
                  <!-- Customiser le formulaire -->
                  <v-switch 
                    :label="$t('absPersonalise')"
                    v-model="abs.active"
                    light
                    color="primary"
                  ></v-switch>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs12 md6>
                  <v-subheader>{{ $t('absCocher') }}</v-subheader>
                  <v-layout row wrap v-for="(field, a) in itemsFieldsAbs" :key="a">
                    <v-flex sm3>
                      <v-checkbox 
                        :disabled="!abs.active || field.value === 'question'"
                        :label="field.text"
                        v-model="abs.labels"
                        :value="field.value"
                        class="primary--text"
                      ></v-checkbox>
                    </v-flex> 
                    <v-flex sm3>
                      <v-checkbox 
                        :disabled="!abs.active || field.value === 'question'"
                        :label="$t('absOblig')"
                        v-model="abs.required"
                        :value="field.value"
                        class="primary--text"
                      ></v-checkbox>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs12 md4>
                  <!-- Mention RGPD -->
                  <v-text-field 
                    v-model="abs.rgpd"
                    :label="$t('absGDPR')"
                    data-vv-name="abs.rgpd"
                    :error="wzErrors.has('abs.rgpd')"
                    :error-messages="wzErrors.collect('abs.rgpd')"
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-expansion-panel-content>
        <!-- personnalisation titre-->
        <v-expansion-panel-content
          :disabled="testBrideStatus('parametre_apercu_message1') || messagingOnOff"
        >
          <div slot="header">
            <v-icon class="mr-2 primary--text">text_fields</v-icon>
            {{ $t("firstLineMessage") | cap }}
          </div>
          <v-card>
            <v-card-text>
              <v-text-field v-for="(l, i) in langs" :key="i" v-model="DSK_NOBODY_MSG1[l.value]" :label="l.text"></v-text-field>
            </v-card-text>
          </v-card>
        </v-expansion-panel-content>
        <!-- personnalisation sous-titre-->
        <v-expansion-panel-content
          :disabled="testBrideStatus('parametre_apercu_message2') || messagingOnOff"
        >
          <div slot="header">
            <v-icon class="mr-2 primary--text">text_fields</v-icon>
            {{ $t("secondLineMessage") | cap }}
          </div>
          <v-card>
            <v-card-text>
              <v-text-field v-for="(l, i) in langs" :key="i" v-model="DSK_NOBODY_MSG2[l.value]" :label="l.text"></v-text-field>
            </v-card-text>
          </v-card>
        </v-expansion-panel-content>
      </v-expansion-panel>

        <!-- personnalisation DU MESSAGING-->
      <v-expansion-panel
        v-else
      >
        <!-- formulaire de demande email-->
        <v-expansion-panel-content
          :disabled="testBrideStatus('parametre_messaging')"
        >
          <div slot="header">
            <v-icon class="mr-2 primary--text">alternate_email</v-icon>{{ $t('askforemail') }}
          </div>
          <v-card class="mb-3">
            <v-card-text>
              <v-layout row wrap>
                <v-flex xs12>
                  <!-- afficher ou non le champ email -->
                  <v-switch 
                    :label="displayemail ? $t('displayemail') + ' ON' : $t('displayemail') + ' OFF'" 
                    v-model="displayemail"
                    light
                    color="primary"
                  ></v-switch>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs12>
                  <!-- afficher ou non le champ email -->
                  <v-switch 
                    :label="displaysms ? $t('displaysms') + ' ON' : $t('displaysms') + ' OFF'" 
                    v-model="displaysms"
                    light
                    color="primary"
                  ></v-switch>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-expansion-panel-content>
        <!-- personnalisation titre-->
        <v-expansion-panel-content
          :disabled="testBrideStatus('parametre_messaging')"
        >
          <div slot="header">
            <v-icon class="mr-2 primary--text">text_fields</v-icon>{{ $t("messaginmsg") }}
          </div>
          <v-card>
            <v-card-text>
              <v-text-field 
                v-for="(l, i) in langs" :key="i"
                v-model="DSK_MESSAGING_MSG[l.value]"
                counter
                :label="l.text"
                maxlength=200
              ></v-text-field>
            </v-card-text>
          </v-card>
        </v-expansion-panel-content>

        <!-- HORAIRES -->
        <v-expansion-panel-content>
          <div slot="header"><v-icon class="primary--text">schedule</v-icon>&nbsp;&nbsp;&nbsp;{{ $t('messginHorair') }}
            <v-tooltip left
              @click.native.stop="openDialog(
                {
                  title: 'Messaging schedules',
                  content: 'THe messaging will only be proposed in the time slots. Outside these time slots, the classic absence form will be offered.'
                }
              )"
            >
              <template slot="activator">
                <v-icon class="infos" color="grey lighten-1" dark>info</v-icon>
              </template>
              <span>{{$t('enSavoirPlus')}}</span>
            </v-tooltip>
          </div>
          <v-card>
            <v-card-text>
              <v-card class="mb-3">
                <v-card-text>
                  <div slot="header">{{ $t("displayTimes") | cap }}</div>
                  <v-layout>
                    <v-flex xs12 sm12 md6>
                      <!-- Horaires d'affichage -->
                      <v-radio-group v-model="form.hours" :hint="$t('defineWidgetHours')" persistent-hint>
                        <v-radio :label="$t('allTheTime') | cap" color="primary" value="all"></v-radio>
                        <v-radio :label="$t('customHours')  | cap" color="primary" value="defined"></v-radio>
                      </v-radio-group>
                    </v-flex>
                  </v-layout>
                  <!-- Définition des horaires -->
                  <v-layout v-if="form.hours == 'defined'" row wrap>
                    <v-flex xs12>
                      <v-btn flat class="primary--text" @click="openHours()">{{ $t('timesSeveralDays') }}<v-icon right>event</v-icon></v-btn>
                    </v-flex>
                    <v-expansion-panel>
                      <v-expansion-panel-content v-for="day in form.days" :key="day.name">
                        <v-layout align-center row spacer slot="header">
                          <v-flex xs12>
                            <span class="hidden-md-and-up">{{ day.name.substring(0, 3) }}. : </span>
                            <span class="hidden-sm-and-down">{{ day.name }} : </span>
                            <span v-if="day.am.active || day.pm.active">
                              <span v-if="day.am.active"> {{ $t('from') }}<code>{{ day.am.start }}</code> {{ $t('to') }} <code>{{ day.am.end }}</code></span>
                              <span v-if="day.am.active && day.pm.active"> {{ $t('and') }}</span>
                              <span v-if="day.pm.active">{{ $t('from') }} <code>{{ day.pm.start }}</code> {{ $t('to') }} <code>{{ day.pm.end }}</code></span>
                            </span>
                            <span v-else>
                              <span>{{ $t("disabledToday") | cap }}</span>
                            </span>
                          </v-flex>
                        </v-layout>
                        <v-card class="grey lighten-3">
                          <v-card-text>
                            <v-layout row wrap>
                              <v-flex xs12 sm6 md2>
                                <!-- Activer le matin -->
                                <v-switch 
                                  :label="$t('activateMorning') | cap " 
                                  v-model="day.am.active"
                                  light
                                  color="primary"
                                ></v-switch>
                              </v-flex>
                              <v-flex xs12 sm6 md2>
                                <!-- Temps Matin -->
                                <v-text-field 
                                  slot="activator"
                                  :label="$t('from') + ` ${ day.name } ` + $t('morning')"
                                  v-model="day.am.start"
                                  prepend-icon="access_time"
                                  :disabled="!day.am.active"
                                  readonly
                                  @click="openTimePicker(day, 'am', 'start')"
                                ></v-text-field>
                              </v-flex>
                              <v-flex xs12 sm6 md2>
                                <v-text-field 
                                  slot="activator"
                                  :label="$t('to') + ` ${ day.name } ` + $t('morning')"
                                  v-model="day.am.end"
                                  prepend-icon="access_time"
                                  :disabled="!day.am.active"
                                  readonly
                                  @click="openTimePicker(day, 'am', 'end')"
                                ></v-text-field>
                              </v-flex>
                            </v-layout>
                            <v-layout row wrap>
                              <v-flex xs12 sm6 md2>
                                <!-- Activer l'après-midi -->
                                <v-switch 
                                  :label="$t('activateAfternoon') | cap " 
                                  v-model="day.pm.active"
                                  light
                                  color="primary"
                                ></v-switch>
                              </v-flex>
                              <!-- Temps Après-midi -->
                              <v-flex xs12 sm6 md2>
                                <v-text-field 
                                  slot="activator"
                                  :label="$t('from') + ` ${ day.name } ` + $t('afternoon')"
                                  v-model="day.pm.start"
                                  prepend-icon="access_time"
                                  :disabled="!day.pm.active"
                                  readonly
                                  @click="openTimePicker(day, 'pm', 'start')"
                                ></v-text-field>
                              </v-flex>
                              <v-flex xs12 sm6 md2>
                                <v-text-field 
                                  slot="activator"
                                  :label="$t('to') + ` ${ day.name } ` + $t('afternoon')"
                                  v-model="day.pm.end"
                                  prepend-icon="access_time"
                                  :disabled="!day.pm.active"
                                  readonly
                                  @click="openTimePicker(day, 'pm', 'end')"
                                ></v-text-field>
                              </v-flex>
                            </v-layout>
                          </v-card-text>
                        </v-card>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-layout>
                </v-card-text>
              </v-card>
            </v-card-text>
          </v-card>
        </v-expansion-panel-content>
      </v-expansion-panel>

      <!-- Validation du formulaire -->
      <div class="text-xs-right">
        <v-btn
          color="primary"
          :block="$vuetify.breakpoint.xsOnly"
          :loading="loadingPost"
          @click.native="checkSwitch()"
        >{{ $t('save') | cap }}<v-icon dark right>save</v-icon>
        </v-btn>
      </div>

      <!-- ON OFF MESSAGING -->
      <!-- <v-dialog v-model="warningMessagingOff" max-width="390" persistent>
        <v-card>
          <v-card-title class="title primary white--text">
            {{ $t('absMesseng') }}
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text >
            {{ $t('absWarning3') }}
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn flat @click.native="warningMessagingOff = false">{{ $t('cancel') }}</v-btn>
            <v-btn flat @click.native="postOptions()">{{ $t('absContinu') }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="warningMessagingOn" max-width="390" persistent>
        <v-card>
          <v-card-title class="title primary white--text">
            {{ $t('absDeactiv') }}
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text >
            {{ $t('absWarning4') }}
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn flat @click.native="warningMessagingOn = false">{{ $t('cancel') }}</v-btn>
            <v-btn flat @click.native="postOptions()">{{ $t('absContinu') }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog> -->

      <!-- dialog Infos -->
      <wz-dialog-infos
        @fermeDialog="fermeDialogInfos"
        :titleDialog="titleDialog"
        :contentDialog="contentDialog"
      >
      </wz-dialog-infos>
      <!-- Time picker -->
      <v-dialog persistent v-model="showTp" lazy max-width="290">
        <v-time-picker 
          v-model="daySelected[amOrPm][startOrEnd]"
          actions
          scrollable
          format="24hr"
          :max="allowed.hours.max"
          :min="allowed.hours.min"
          color="primary"
        >
          <v-spacer></v-spacer>
          <v-btn flat @click="showTp = false; daySelected[amOrPm][startOrEnd] = tmpHours">{{ $t('cancel') | cap }}</v-btn>
          <v-btn flat color="primary" @click="showTp = false">{{ $t('submit') | cap }}</v-btn>
        </v-time-picker>
      </v-dialog>

      <!-- Appliquer les horaires d'une journée -->
      <v-dialog v-model="showHours" scrollable persistent width="350px">
        <v-card>
          <v-card-title class="primary white--text">{{ $t('applySchedules') | cap }}</v-card-title>
          <v-divider></v-divider>
          <v-card-text style="height: 400px;">
            <v-select
              :items="days"
              v-model="dayHours"
              :label="$t('applyHours')" 
              return-object
            ></v-select>
            <v-data-table
              :headers="headersDays"
              :items="days"
              v-model="daysTmp"
              item-key="text"
              select-all="primary"
              class="elevation-1"
              hide-actions
              :total-items="7"
            >
              <template slot="headerCell" slot-scope="props">
                <span class="subheading">{{ props.header.text }}</span>
              </template>
              <template slot="items" slot-scope="props">
                <td>
                  <v-checkbox
                    hide-details
                    class="primary--text"
                    v-model="props.selected"
                  ></v-checkbox>
                </td>
                <td>{{ props.item.text }}</td>
              </template>
            </v-data-table>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn flat @click="showHours = false">{{ $t('cancel') }}</v-btn>
            <v-btn :disabled="!daysTmp.length" color="primary" flat @click="submitHours()">{{ $t('submit') }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
export default {
  data () {
    return {
      dialogProgress: false,
      absOnOff: true,
      displayemail: false,
      displaysms: false,
      // warningMessagingOff: false,
      // warningMessagingOn: false,
      // warningMessaging: false,
      titleDialog: '',
      contentDialog: '',
      abs: {
        active: true,
        rgpd: '',
        fields: [],
        required: ['question']
      },
      DSK_NOBODY_MSG1: '',
      DSK_NOBODY_MSG2: '',
      DSK_MESSAGING_MSG: '',
      langs: [
        { text: _.upperFirst(this.$t('french')), value: 'FR' },
        { text: _.upperFirst(this.$t('english')), value: 'EN' },
        { text: _.upperFirst(this.$t('spanish')), value: 'ES' },
        { text: _.upperFirst(this.$t('german')), value: 'DE' },
        { text: _.upperFirst(this.$t('italian')), value: 'IT' },
        { text: _.upperFirst(this.$t('portuguese')), value: 'PT' }
      ],
      displayDefault: {},
      itemsFieldsAbs: [
        { text: this.$t('absfname'), value: 'fname' },
        { text: this.$t('abslname'), value: 'lname' },
        { text: this.$t('abstel'), value: 'tel' },
        { text: 'Email', value: 'email' },
        { text: this.$t('abscomp'), value: 'company' },
        { text: this.$t('absmessag'), value: 'question' }
      ],
      form: {
        // horaires d'affichage
        hours: '',
        days: [
          {
            name: this.$t('monday'),
            am: { start: '08:00', end: '12:00', active: true },
            pm: { start: '14:00', end: '18:00', active: true }
          },
          {
            name: this.$t('tuesday'),
            am: { start: '08:00', end: '12:00', active: true },
            pm: { start: '14:00', end: '18:00', active: true }
          },
          {
            name: this.$t('wednesday'),
            am: { start: '08:00', end: '12:00', active: true },
            pm: { start: '14:00', end: '18:00', active: true }
          },
          {
            name: this.$t('thursday'),
            am: { start: '08:00', end: '12:00', active: true },
            pm: { start: '14:00', end: '18:00', active: true }
          },
          {
            name: this.$t('friday'),
            am: { start: '08:00', end: '12:00', active: true },
            pm: { start: '14:00', end: '18:00', active: true }
          },
          {
            name: this.$t('saturday'),
            am: { start: '08:00', end: '12:00', active: true },
            pm: { start: '14:00', end: '18:00', active: true }
          },
          {
            name: this.$t('sunday'),
            am: { start: '08:00', end: '12:00', active: true },
            pm: { start: '14:00', end: '18:00', active: true }
          }
        ],
        // URLs d'affichage
        urls: '',
        rules: []
      },
      // time pickers
      showTp: false,
      daySelected: {},
      tmpHours: null,
      amOrPm: 'am',
      startOrEnd: 'start',
      allowed: { hours: { min: '0:00', max: '12:00' } },
      dependency: '',

      // dialog appliquer les horaires
      showHours: false,
      daysTmp: [],
      dayHours: null,
      days: [
        { text: _.upperFirst(this.$t('monday')), value: 0 },
        { text: _.upperFirst(this.$t('tuesday')), value: 1 },
        { text: _.upperFirst(this.$t('wednesday')), value: 2 },
        { text: _.upperFirst(this.$t('thursday')), value: 3 },
        { text: _.upperFirst(this.$t('friday')), value: 4 },
        { text: _.upperFirst(this.$t('saturday')), value: 5 },
        { text: _.upperFirst(this.$t('sunday')), value: 6 }
      ],
      // loaders
      loadingGet: false,
      loadingPost: false,
      /**
       * affiche/cache la fenetre de dialog de création
       * @type {Boolean}
       */
      showDialogCreate: false,
      showDialogMotif: false
    }
  },
  created () {
    this.daySelected = this.form.days[0]
    this.dayHours = { text: this.form.days[0].name, value: 0 }
    this.getOptions()
    /* eslint-disable */
    if (typeof (defautMotif) !== 'undefined') {
      defautMotif = 'settings_absence'
    }
    else {
      setTimeout (function () {
        if (typeof (defautMotif) !== 'undefined') {
          defautMotif = 'settings_absence'
        }
      }, 800);
    }
    /* eslint-enable */
  },

  computed: {
    headersDays () {
      return !this.daysTmp.length
      ? [{text: this.$t('allDays'), align: 'left', sortable: false}]
      : [{text: this.$t('noDays'), align: 'left', sortable: false}]
    }
  },

  mounted () {
    // if (!this.$cookie.get('blockInstallProgress') && this.$store.state._User.ongoingTuto) {
    //   this.openDialogProgress()
    // }
    if (this.$store.state._User.lang === 'en') {
      this.langs = [
        { text: _.upperFirst(this.$t('english')), value: 'EN' },
        { text: _.upperFirst(this.$t('french')), value: 'FR' },
        { text: _.upperFirst(this.$t('spanish')), value: 'ES' },
        { text: _.upperFirst(this.$t('german')), value: 'DE' },
        { text: _.upperFirst(this.$t('italian')), value: 'IT' },
        { text: _.upperFirst(this.$t('portuguese')), value: 'PT' }
      ]
    } else if (this.$store.state._User.lang === 'es') {
      this.langs = [
        { text: _.upperFirst(this.$t('spanish')), value: 'ES' },
        { text: _.upperFirst(this.$t('english')), value: 'EN' },
        { text: _.upperFirst(this.$t('french')), value: 'FR' },
        { text: _.upperFirst(this.$t('german')), value: 'DE' },
        { text: _.upperFirst(this.$t('italian')), value: 'IT' },
        { text: _.upperFirst(this.$t('portuguese')), value: 'PT' }
      ]
    }
  },

  methods: {
    openTimePicker (day, amOrPm, startOrEnd) {
      this.showTp = true // ouverture du dialog
      this.daySelected = day
      this.amOrPm = amOrPm
      this.startOrEnd = startOrEnd
      this.tmpHours = this.daySelected[amOrPm][startOrEnd]
      // heures et minutes autorisées dans le time pîcker
      this.allowed.hours = amOrPm === 'am'
      ? { min: '0:00', max: '12:59' } // matin
      : { min: '12:00', max: '23:59' } // aprem
    },

    /**
     * Gestion de l'application d'horaires à plusieurs jours
     */
    openHours () {
      this.showHours = true
    },
    submitHours () {
      this.showHours = false
      // pour tous les jours sélectionnés
      // il faut changer leurs horaires
      // par ceux du jour sélectionné
      const daySelected = this.form.days.find(d => d.name === this.dayHours.text)
      this.daysTmp.forEach(day => {
        let d = this.form.days.find(d => d.name === day.text.toLowerCase())
        d.am = _.cloneDeep(daySelected.am)
        d.pm = _.cloneDeep(daySelected.pm)
      })
      this.daysTmp = []
    },
    // ---------------------------
    // open dialog Infos
    openDialog (data) {
      this.titleDialog = data.title
      this.contentDialog = data.content
    },
    // ---------------------------
    // close dialog Infos
    fermeDialogInfos () {
      this.titleDialog = ''
    },

    // test le status de la bride pour afficher le menu
    testBrideStatus (name) {
      // console.log('name', name)
      let brides = this.$store.state._User.brides
      // console.log('brides', brides)
      if (brides) {
        let resultat = brides.find(brides => brides.brideName === name)
        if (resultat) {
          if (resultat.status === '0') {
            return true
          } else {
            return false
          }
        }
      }
    },

    getOptions () {
      this.loadingGet = true
      this.axios
        .get(
          'get/settings_absence.php?desk=' +
            this.$store.state._Sites.siteSelected.LIC_DSK_ID
        )
        .then(response => {
          /* {"rgpd":"En vertu de la loi","labels":["lname","email*"],"required":["email"]} */
          response.data.DSK_CUSTOM_ABS =
            response.data.DSK_CUSTOM_ABS || '{}'
          this.abs = _.merge(
            { active: response.data.DSK_CUSTOM_ABS_ONOFF === '1' },
            JSON.parse(response.data.DSK_CUSTOM_ABS)
          )
          // if (response.data.DSK_CUSTOM_ABS_ONOFF === '1') {
          //   this.absOnOff = true
          // } else {
          //   this.absOnOff = false
          // }
          if (typeof this.abs.required === 'undefined' || !this.abs.required || this.abs.required === null) {
            this.abs.required = []
          }
          try {
            this.DSK_NOBODY_MSG1 = JSON.parse(response.data.DSK_NOBODY_MSG1) || {}
          } catch (error) {}
          try {
            this.DSK_NOBODY_MSG2 = JSON.parse(response.data.DSK_NOBODY_MSG2) || {}
          } catch (error) {}
          try {
            this.DSK_MESSAGING_MSG = JSON.parse(response.data.DSK_MESSAGING_MSG) || {}
            this.displayemail = this.DSK_MESSAGING_MSG.onoff === '1'
            this.displaysms = this.DSK_MESSAGING_MSG.smsonoff === '1'
          } catch (error) {}
          this.absOnOff = response.data.DSK_MESSAGING_ONOFF !== '1'
          this.displayDefault = response.data.DSK_OPTIONS.split('|')[0]

          // options horaires
          this.form.hours = response.data.DSK_SCHEDULES_MESSAGING.split('|')[0]
          let hours = response.data.DSK_SCHEDULES_MESSAGING.split('|')
          // lundi
          this.form.days[0].am.active = !_.isEmpty(hours[1] + hours[2] + hours[3] + hours[4]) && !_.isNil(hours[1]) && !_.isNil(hours[2]) && !_.isNil(hours[3]) && !_.isNil(hours[4])
          this.form.days[0].am.start = (this.form.days[0].am.active) ? hours[1] + ':' + hours[2] : '00:00'
          this.form.days[0].am.end = (this.form.days[0].am.active) ? hours[3] + ':' + hours[4] : '00:00'
          this.form.days[0].pm.active = !_.isEmpty(hours[5] + hours[6] + hours[7] + hours[8])
          this.form.days[0].pm.start = (this.form.days[0].pm.active) ? hours[5] + ':' + hours[6] : '12:00'
          this.form.days[0].pm.end = (this.form.days[0].pm.active) ? hours[7] + ':' + hours[8] : '12:00'
          // mardi
          this.form.days[1].am.active = !_.isEmpty(hours[9] + hours[10] + hours[11] + hours[12])
          this.form.days[1].am.start = (this.form.days[1].am.active) ? hours[9] + ':' + hours[10] : '00:00'
          this.form.days[1].am.end = (this.form.days[1].am.active) ? hours[11] + ':' + hours[12] : '00:00'
          this.form.days[1].pm.active = !_.isEmpty(hours[13] + hours[14] + hours[15] + hours[16])
          this.form.days[1].pm.start = (this.form.days[1].am.active) ? hours[13] + ':' + hours[14] : '12:00'
          this.form.days[1].pm.end = (this.form.days[1].am.active) ? hours[15] + ':' + hours[16] : '12:00'
          // mercredi
          this.form.days[2].am.active = !_.isEmpty(hours[17] + hours[18] + hours[19] + hours[20])
          this.form.days[2].am.start = (this.form.days[2].am.active) ? hours[17] + ':' + hours[18] : '00:00'
          this.form.days[2].am.end = (this.form.days[2].am.active) ? hours[19] + ':' + hours[20] : '00:00'
          this.form.days[2].pm.active = !_.isEmpty(hours[21] + hours[22] + hours[23] + hours[24])
          this.form.days[2].pm.start = (this.form.days[2].pm.active) ? hours[21] + ':' + hours[22] : '12:00'
          this.form.days[2].pm.end = (this.form.days[2].pm.active) ? hours[23] + ':' + hours[24] : '12:00'
          // jeudi
          this.form.days[3].am.active = !_.isEmpty(hours[25] + hours[26] + hours[27] + hours[28])
          this.form.days[3].am.start = (this.form.days[3].am.active) ? hours[25] + ':' + hours[26] : '00:00'
          this.form.days[3].am.end = (this.form.days[3].am.active) ? hours[27] + ':' + hours[28] : '00:00'
          this.form.days[3].pm.active = !_.isEmpty(hours[29] + hours[30] + hours[31] + hours[32])
          this.form.days[3].pm.start = (this.form.days[3].pm.active) ? hours[29] + ':' + hours[30] : '12:00'
          this.form.days[3].pm.end = (this.form.days[3].pm.active) ? hours[31] + ':' + hours[32] : '12:00'
          // vendredi
          this.form.days[4].am.active = !_.isEmpty(hours[33] + hours[34] + hours[35] + hours[36])
          this.form.days[4].am.start = (this.form.days[4].am.active) ? hours[33] + ':' + hours[34] : '00:00'
          this.form.days[4].am.end = (this.form.days[4].am.active) ? hours[35] + ':' + hours[36] : '00:00'
          this.form.days[4].pm.active = !_.isEmpty(hours[37] + hours[38] + hours[39] + hours[40])
          this.form.days[4].pm.start = (this.form.days[4].pm.active) ? hours[37] + ':' + hours[38] : '12:00'
          this.form.days[4].pm.end = (this.form.days[4].pm.active) ? hours[39] + ':' + hours[40] : '12:00'
          // samedi
          this.form.days[5].am.active = !_.isEmpty(hours[41] + hours[42] + hours[43] + hours[44])
          this.form.days[5].am.start = (this.form.days[5].am.active) ? hours[41] + ':' + hours[42] : '00:00'
          this.form.days[5].am.end = (this.form.days[5].am.active) ? hours[43] + ':' + hours[44] : '00:00'
          this.form.days[5].pm.active = !_.isEmpty(hours[45] + hours[46] + hours[47] + hours[48])
          this.form.days[5].pm.start = (this.form.days[5].pm.active) ? hours[45] + ':' + hours[46] : '12:00'
          this.form.days[5].pm.end = (this.form.days[5].pm.active) ? hours[47] + ':' + hours[48] : '12:00'
          // dimanche
          this.form.days[6].am.active = !_.isEmpty(hours[49] + hours[50] + hours[51] + hours[52])
          this.form.days[6].am.start = (this.form.days[6].am.active) ? hours[49] + ':' + hours[50] : '00:00'
          this.form.days[6].am.end = (this.form.days[6].am.active) ? hours[51] + ':' + hours[52] : '00:00'
          this.form.days[6].pm.active = !_.isEmpty(hours[53] + hours[54] + hours[55] + hours[56])
          this.form.days[6].pm.start = (this.form.days[6].pm.active) ? hours[53] + ':' + hours[54] : '12:00'
          this.form.days[6].pm.end = (this.form.days[6].pm.active) ? hours[55] + ':' + hours[56] : '12:00'
        })
        .catch(_ => {
          // window.alert('totejfojiz ezuihf uihezhf uihs of uge')
        })
        .then(_ => {
          this.loadingGet = false
        })
    },
    checkSwitch () {
      this.postOptions()
    },
    postOptions () {
      // this.warningMessagingOn = false
      // this.warningMessagingOff = false
      // Données modifiées et à renvoyer
      let dataToPost = new window.FormData()
      // onboarding
      let steps = JSON.parse(this.$store.state._User.remainingSteps)
      // si cette étape est encore dans le tableau
      if (steps && typeof steps !== 'undefined' && steps.indexOf('INS_SETTINGS_HORSLIGNE')) {
        // on l'efface du tableau
        steps.splice(steps.indexOf('INS_SETTINGS_HORSLIGNE'), 1)
        // mise à jour du store _User
        this.$store.commit('_User/MAJ_PROGRESSION', {
          remainingSteps: JSON.stringify(steps)
        })
      }
      // this.$store.state._User.remainingSteps = JSON.stringify(steps)
      // this.$store.state._User.installProgress += 10

      dataToPost.append(
        'DSK_ID',
        this.$store.state._Sites.siteSelected.LIC_DSK_ID
      )
      dataToPost.append(
        'LIC_KEY',
        this.$store.state._Sites.siteSelected.LIC_KEY
      )
      dataToPost.append(
        'LIC_ID',
        this.$store.state._Sites.siteSelected.LIC_ID
      )
      dataToPost.append('ENT_ID', this.$store.state._User.entId)

      dataToPost.append('DSK_CUSTOM_ABS_ONOFF', this.abs.active ? '1' : '0')

      let custom2 = _.clone(this.abs)
      console.log('custom2', JSON.stringify(custom2))
      let postMessaging = 0
      delete custom2.active // supprime la clé 'active' de la colonne à mettre à jour
      dataToPost.append('DSK_CUSTOM_ABS', JSON.stringify(custom2))
      dataToPost.append('DSK_NOBODY_MSG1', JSON.stringify(this.DSK_NOBODY_MSG1))
      dataToPost.append('DSK_NOBODY_MSG2', JSON.stringify(this.DSK_NOBODY_MSG2))
      this.DSK_MESSAGING_MSG['onoff'] = this.displayemail ? '1' : '0'
      this.DSK_MESSAGING_MSG['smsonoff'] = this.displaysms ? '1' : '0'
      dataToPost.append('DSK_MESSAGING_MSG', JSON.stringify(this.DSK_MESSAGING_MSG))
      dataToPost.append('DSK_MESSAGING_ONOFF', postMessaging)

      // options horaires
      let hours = this.form.hours
      _.each(this.form.days, day => {
        hours += (day.am.active) // si Watcheezy actif le matin
        ? '|' + day.am.start.split(':')[0] + '|' + day.am.start.split(':')[1] + '|' + day.am.end.split(':')[0] + '|' + day.am.end.split(':')[1]
        : '||||'
        hours += (day.pm.active) // si Watcheezy actif l'aprem
        ? '|' + day.pm.start.split(':')[0] + '|' + day.pm.start.split(':')[1] + '|' + day.pm.end.split(':')[0] + '|' + day.pm.end.split(':')[1]
        : '||||'
      })
      dataToPost.append('DSK_SCHEDULES_MESSAGING', hours)

      this.loadingPost = true
      this.axios
        .post('post/settings_absence.php', dataToPost, {
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
        })
        .then(response => {
          let siteUpdate = _.clone(this.$store.state._Sites.siteSelected)

          this.$store.commit('_Sites/UPDATE_SITE_SETTINGS', siteUpdate)
          this.$store.commit('_Sites/UPDATE_SITE_SELECTED', siteUpdate)
          this.$store.dispatch('_Notifier/NEW_NOTIF', {
            message: this.$t('modifSuccess'),
            context: 'success'
          })
        })
        .catch(_ => {
          this.$store.dispatch('_Notifier/NEW_NOTIF', {
            message: this.$t('modifFailure'),
            context: 'error'
          })
        })
        .then(_ => {
          this.loadingPost = false
        })
    },

    switchAbs () {
      // this.warningMessaging = true
      this.abs.active ? this.abs.active = true : this.abs.active = false
      // @click.native="!onOff ? warningChatOff = true : ''"
    },

    // ---------------------------
    // close dialog Progression install
    fermeDialogProgress () {
      this.dialogProgress = false
    },
    // ---------------------------
    // Ouvre la dialogueBox de progression de l'installation
    openDialogProgress () {
      this.dialogProgress = true
    }
  },

  watch: {
    '$store.state._Sites.siteSelected': function (v) {
      if (v) {
        this.getOptions()
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/settings/Absence.vue